
import { Switch } from "@/components/ui/switch";
import { cn } from "@/lib/utils";

interface SettingsToggleItemProps {
  title: string;
  description: string;
  checked: boolean;
  onCheckedChange: () => void;
  enableRpgMode: boolean;
  darkMode: boolean;
  icon?: React.ReactNode;
}

const SettingsToggleItem: React.FC<SettingsToggleItemProps> = ({
  title,
  description,
  checked,
  onCheckedChange,
  enableRpgMode,
  darkMode,
  icon
}) => {
  return (
    <div className="flex items-center justify-between">
      <div className="space-y-0.5 flex-1 mr-4">
        <h4 className={cn(
          "font-medium text-sm flex items-center gap-2",
          enableRpgMode ? (
            darkMode ? "text-amber-100 font-bold" : "text-amber-900 font-bold"
          ) : (
            darkMode ? "text-[#FBF3F1]" : "text-[#1E0C46]"
          )
        )}>
          {icon}
          {title}
        </h4>
        <p className={cn(
          "text-sm leading-relaxed",
          enableRpgMode ? (
            darkMode ? "text-amber-200/90" : "text-amber-800/90"
          ) : (
            darkMode ? "text-[#FBF3F1]/70" : "text-[#1E0C46]/70"
          )
        )}>
          {description}
        </p>
      </div>
      <Switch 
        checked={checked} 
        onCheckedChange={onCheckedChange}
        className={cn(
          "shrink-0",
          enableRpgMode ? (
            checked ? (
              darkMode 
                ? "data-[state=checked]:bg-amber-600 border-amber-500"
                : "data-[state=checked]:bg-amber-600 border-amber-500"
            ) : (
              darkMode 
                ? "data-[state=unchecked]:bg-amber-800/40 border-amber-700/60"
                : "data-[state=unchecked]:bg-amber-200/60 border-amber-400/60"
            )
          ) : (
            checked 
              ? "data-[state=checked]:bg-[#00FF99]" 
              : (darkMode ? "data-[state=unchecked]:bg-[#2d1a45]/60" : "data-[state=unchecked]:bg-gray-200")
          )
        )}
      />
    </div>
  );
};

export default SettingsToggleItem;
